import React from 'react';

const LoadingScreen = ({ icon, text }) => {
  // Clone the icon element to add the necessary styling classes.
  // This makes the component flexible, allowing any lucide-react icon to be passed as a prop.
  const IconComponent = React.cloneElement(icon, {
    className: "h-12 w-12 text-muted-foreground mx-auto mb-4 animate-pulse"
  });

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        {IconComponent}
        <p className="text-muted-foreground">{text}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
